import React, { useEffect, useState } from 'react'
import { Box, Chip, Divider, Icon, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import AdxCheckbox from 'components/custom/AdxCheckbox'
import AdxSwitch from 'components/reusable/switch/AdxSwitch'
import { useQuery } from 'react-query'
import { getForm } from 'services/api/modules/performance/appraisal/form'
import { getAllDepartment } from 'services/api/modules/performance/appraisal/department'
import { getEvaluation } from 'services/api/modules/performance/appraisal/evaluation'
import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'
import FormEvalPreview from '../../viewForm/view/formEvalPreview'
import AdxButton from 'components/custom/AdxButton'

const matching = [
  { id: 1, title: 'Self - Reviewer and Reviewee will be the same person' },
  { id: 2, title: 'Downstream - Supervisor as reviewer and Subordinate as reviewee' },
  { id: 3, title: 'Upstream - Subordinate as reviewer and Supervisor as reviewee' },
  {
    id: 4,
    title: 'Custom - Upload external matching CSV when this evalulation is added to an appraisal',
  },
]

const PreviewEvaluation = ({ selectEvalId, handleClosePreview }) => {
  const [evaluationTitle, setEvaluationTitle] = useState('')
  const [description, setDescription] = useState('')
  const [getQuery, setGetQuery] = useState(false)
  const [formTitle, setFormTitle] = useState('')
  const [formId, setFormId] = useState('')
  const [departmentSelected, setDepartmentSelected] = useState([])
  const [matchingSelected, setMatchingSelected] = useState('')
  const [switchFeedback, setSwitchFeedback] = useState(true)
  const [selectReviewer, setSelectReviewer] = useState(false)
  const [selectReviewee, setSelectReviewee] = useState(false)
  const [switchAnonymous, setSwitchAnonymous] = useState(false)
  const [previewForm, setPreviewForm] = useState(false)

  const {
    isLoading,
    error: fetchError,
    data: evaluationData,
  } = useQuery(['evalData', selectEvalId], async () => {
    const { data } = await getEvaluation(selectEvalId)
    return data
  })

  const { data: formData } = useQuery(
    ['formData', evaluationData?.['Evaluation']?.['form_id']],
    async () => {
      const { data } = await getForm(evaluationData?.['Evaluation']?.['form_id'])
      return data
    },
    { enabled: getQuery }
  )
  const { data: departmentData } = useQuery(
    ['allDepartmentData', evaluationData?.['Evaluation']?.['participant_departments']],
    async () => {
      const newData = { name: 'All Departments', id: 'all' }
      let { data } = await getAllDepartment()
      if (data) {
        data.push(newData)
        const evalDepartments = evaluationData?.['Evaluation']?.['participant_departments']
        let arr = []

        data?.map((item) =>
          evalDepartments.map((evalDept) => (item.id === evalDept ? arr.push(item) : null))
        )
        data = arr
        return data
      }
    },
    { enabled: getQuery }
  )

  useEffect(() => {
    const data = formData?.['form']
    const id = data?.['id']
    setFormTitle(data)
    setFormId(id)
  }, [formData])

  useEffect(() => {
    setDepartmentSelected(departmentData)
  }, [departmentData])

  useEffect(() => {
    const data = evaluationData?.['Evaluation']

    data ? setGetQuery(true) : setGetQuery(false)

    setEvaluationTitle(data?.['title'])

    setDescription(data?.['description'])

    matching.map((item) => {
      if (item.id === data?.['participant_match_type_id']) {
        setMatchingSelected(item.title)
      }
    })

    data?.['has_feedback'] === 1 ? setSwitchFeedback(true) : setSwitchFeedback(false)

    data?.['is_anonymous'] === 1 ? setSwitchAnonymous(true) : setSwitchAnonymous(false)

    data?.['is_revieweeView'] === 1 ? setSelectReviewee(true) : setSelectReviewee(false)

    data?.['is_reviewerView'] === 1 ? setSelectReviewer(true) : setSelectReviewer(false)
  }, [evaluationData])

  const handleFormPreview = () => {
    setPreviewForm(!previewForm)
  }

  const handleReviewer = () => {
    setSelectReviewer(!selectReviewer)
  }

  const handleReviewee = () => {
    setSelectReviewee(!selectReviewee)
  }

  return (
    <>
      {!previewForm && (
        <Box
          sx={{
            backgroundColor: 'gray-background.main',
            minHeight: '100vh',
            maxWidth: '100vw',
          }}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          {/* Header */}
          <Box
            sx={{
              width: '100%',
              height: 75,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: 'white.main',
              borderBottom: '1px solid',
              borderBottomColor: 'gray-line.main',
              position: 'fixed',
              zIndex: 999,
            }}
            px={'40px'}
          >
            <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
              <Typography variant="h4">{evaluationTitle}</Typography>
              <AdxStatusBar
                status={{
                  text: 'Preview',
                  color: 'alternate.main',
                  bgColor: 'alternate.light',
                }}
                py={1 / 3}
                sx={{ borderRadius: '4.5px' }}
              />
            </Box>
            <Box display="flex" alignItems="center" gap={3}>
              <Icon onClick={handleClosePreview} sx={{ fontSize: 25, cursor: 'pointer' }}>
                close
              </Icon>
            </Box>
          </Box>

          {/* Body */}
          {/* General */}
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            sx={{
              backgroundColor: 'white.main',
              width: '67%',
              borderRadius: '10px',
              boxShadow: '0px 0px 10px lightgray',
              gap: 1.5,
              px: '40px',
              mt: '137px',
              py: '10px',
            }}
          >
            <Typography variant="h4" color="alternate.main" fontWeight="600">
              General
            </Typography>
            <Divider />

            <Typography variant="body1">Evaluation Name</Typography>
            <AdxInput placeholder={evaluationTitle} disabled />

            <Typography variant="body1">Description</Typography>
            <AdxInput multiline placeholder={description} disabled />

            <Typography variant="body1">Evaluation Form Selection</Typography>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <AdxInput size="standard" placeholder={formTitle?.['title']} disabled />
              <AdxButton
                variant={'contained'}
                sx={{ width: 200 }}
                size="standard"
                onClick={handleFormPreview}
              >
                Preview
              </AdxButton>
            </Box>
          </Box>

          {/* Participant */}
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            sx={{
              backgroundColor: 'white.main',
              width: '67%',
              borderRadius: '10px',
              boxShadow: '0px 0px 10px lightgray',
              gap: 1.5,
              px: '40px',
              mt: '25px',
              py: '10px',
            }}
          >
            <Typography variant="h4" color="alternate.main" fontWeight="600">
              Participant
            </Typography>
            <Divider />

            <Typography variant="body1">Department Selection</Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                overflowX: 'auto',
                gap: '5px',
              }}
            >
              {departmentSelected?.map((value) => (
                <Chip key={value.id} label={value.name} />
              ))}
            </Box>

            {/* Matching rule */}
            <Typography variant="body1">Matching Method </Typography>
            <AdxInput size="standard" placeholder={matchingSelected} disabled />
          </Box>

          {/* Other */}
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            sx={{
              backgroundColor: 'white.main',
              width: '67%',
              borderRadius: '10px',
              boxShadow: '0px 0px 10px lightgray',
              gap: 1.5,
              px: '40px',
              mt: '25px',
              mb: '150px',
              py: '10px',
            }}
          >
            <Typography variant="h4" color="alternate.main" fontWeight="600">
              Other
            </Typography>
            <Divider />

            {/* Feedback visibility */}
            <Box>
              <Typography variant="body1">Evaluation Result Visibility:</Typography>
              <Typography variant="subtitle2" color="gray">
                Evaluation results will be visible to the selected type of user(s).
              </Typography>
            </Box>
            <Box sx={{ display: 'flex' }}>
              <AdxFormControlLabel
                type="no-fill"
                control={<AdxCheckbox onChange={handleReviewer} checked={selectReviewer} />}
                label="Reviewer"
                disabled
              />
              <AdxFormControlLabel
                type="no-fill"
                control={<AdxCheckbox onChange={handleReviewee} checked={selectReviewee} />}
                label="Reviewee"
                disabled
              />
            </Box>

            {/* Enabling evaluation feedback */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Typography variant="body1">Evaluation feedback</Typography>
                <Typography variant="subtitle2" color="gray">
                  Reviewee is able to leave feedback after they have reviewed their evaluation
                  result.
                </Typography>
              </Box>
              <AdxSwitch
                label1="Enabled"
                label2="Disabled"
                state={switchFeedback}
                onChange={() => {
                  setSwitchFeedback(!switchFeedback)
                }}
                disabled
              />
            </Box>

            {/* Anonymous submission */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Typography variant="body1">Anonymous submission</Typography>
                <Typography variant="subtitle2" color="gray">
                  Reviewee is able to submit evaluation anonymously.
                </Typography>
              </Box>
              <AdxSwitch
                label1="Enabled"
                label2="Disabled"
                state={switchAnonymous}
                onChange={() => {
                  setSwitchAnonymous(!switchAnonymous)
                }}
                disabled
              />
            </Box>
          </Box>
        </Box>
      )}
      {previewForm && <FormEvalPreview formId={formId} handlePreview={handleFormPreview} />}
    </>
  )
}

export default PreviewEvaluation
